import React from 'react';

import { TypeNamePageBlocks } from '@/utils/constants';
import {
  PageBlockUnion,
  PageQuickAccessBar,
  PageSocialNetworksBlock,
} from '@/components/common/Providers/GraphqlProvider/generated';
import { AlertBlockSkeleton } from '@/components/blocks/PageAlertsBlock/public/AlertBlock';
import { CabinetSkeleton } from '@/components/blocks/PageCabinetBlock/public/Cabinet';
import { CustomBlockSkeleton } from '@/components/blocks/PageCustomBlock/public/CustomBlock';
import { EventsSkeleton } from '@/components/blocks/PageEventsBlock/public/Events';
import { MapBlockPresentationSkeleton } from '@/components/blocks/PageMapBlock/public/MapBlockPresentation';
import { NewsSkeleton } from '@/components/blocks/PageNewsletterBlock/public/News';
import { ProceduresSkeleton } from '@/components/blocks/PageProceduresBlock/public/Procedures';
import { QuickAccessBarSkeleton } from '@/components/blocks/PageQuickAccessBar/public/QuickAccessBar';
import { LastUpdateSkeleton } from '@/components/blocks/PageRegulationsBlock/public/LastUpdate';
import { BannerSkeleton } from '@/components/blocks/PageSliderBlock/public/Banner';
import { PressRoomSocialNetworksWithoutContextSkeleton } from '@/components/blocks/PageSnsBlock/public/PressRoomSocialNetworksWithoutContext';
import { FollowUsSkeleton } from '@/components/blocks/PageSocialNetworksBlock/public/FollowUs';
import { TaxesSkeleton } from '@/components/blocks/PageTaxesBlock/public/Taxes';

type Props = {
  block: PageBlockUnion & { __typename?: string };
};

export default function PublicBlockSkeletonRegistry({ block }: Props) {
  switch (block.__typename) {
    case TypeNamePageBlocks.PageSliderBlock:
      return <BannerSkeleton />;
    case TypeNamePageBlocks.PageCabinetBlock:
      return <CabinetSkeleton />;
    case TypeNamePageBlocks.PageTaxesBlock:
      return <TaxesSkeleton />;
    case TypeNamePageBlocks.PageNewsletterBlock:
      return <NewsSkeleton />;
    case TypeNamePageBlocks.PageProceduresBlock:
      return <ProceduresSkeleton />;
    case TypeNamePageBlocks.PageRegulationsBlock:
      return <LastUpdateSkeleton />;
    case TypeNamePageBlocks.PageEventsBlock:
      return <EventsSkeleton />;
    case TypeNamePageBlocks.PageSocialNetworksBlock:
      return <FollowUsSkeleton currentPageSocialNetworks={block as PageSocialNetworksBlock} />;
    case TypeNamePageBlocks.PageQuickAccessBar:
      return <QuickAccessBarSkeleton block={block as PageQuickAccessBar} />;
    case TypeNamePageBlocks.PageCustomBlock:
      return <CustomBlockSkeleton />;
    case TypeNamePageBlocks.PageSnsBlock:
      return <PressRoomSocialNetworksWithoutContextSkeleton />;
    case TypeNamePageBlocks.PageAlertsBlock:
      return <AlertBlockSkeleton />;
    case TypeNamePageBlocks.PageMapBlock:
      return (
        <div className="container mx-auto max-w-screen-xl p-5">
          <MapBlockPresentationSkeleton />
        </div>
      );
    default:
      return null;
  }
}
